module.exports = __webpack_public_path__ + "media/images/crm/post-image-7d8cb43bf779d9af3c900c8137d3a055.png";